<template>
  <vue-notification class="notification"
                    position="top right"
                    :duration="5000"
                    :max="3"
                    close-on-click>
    <template slot="body"
              slot-scope="props">
      <div class="system-notification"
           :class="notificationClassesMap[props.item.type]"
           @click="props.close">
        <div class="text">
          {{ props.item.text }}
        </div>
      </div>
    </template>
  </vue-notification>
</template>

<script>
export default {
  data() {
    return {
      notificationClassesMap: {
        error: 'error',
        warn: 'warn',
        success: 'success',
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .notification {
    top: 135px !important;
    right: 30px !important;
    z-index: 20000 !important;
    width: auto !important;
  }

  :deep(.notification-wrapper) {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  .system-notification {
    height: 38px;
    padding: 12px;
    font-size: 12px;
    font-weight: normal;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;

    &.error,
    &.warn,
    &.success {
      color: #fff;
    }
    
    &.error {
      background-color: color.adjust(#f25b5b, $lightness: 10%);
    }

    &.warn {
      background-color: color.adjust(#ec971d, $lightness: 10%);
    }

    &.success {
      background-color: color.adjust(#22c883, $lightness: 10%);
    }
  }
</style>
